// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".thank-page[data-v-61219182]{text-align:center;align-content:center;white-space:pre-line}.container[data-v-61219182]{margin-top:1rem;margin-bottom:1rem}.privacy-link[data-v-61219182]{font-weight:bolder}.privacy-text[data-v-61219182]{font-size:small}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
